import { useEffect, useImperativeHandle } from "react";
import { wait } from "../utils/wait";

/**
 * Hook para manejar animaciones y efectos del juego
 */
export const useGameAnimations = ({
  ref,
  currentQuestionIndex,
  questions,
  words,
  userAnswers,
  setGridShown,
  setFoundWordsArray,
  updateGridSize,
  setUserAnswers
}) => {

  useImperativeHandle(ref, () => ({
    animateEntry: async () => {
      setGridShown(true);
    },
    animateFail: async () => {
    },
    getUserAnswer: () => {
      if (currentQuestionIndex + 1 < questions.length) {
        wait(200);
        setGridShown(false);
        wait(200);
        setUserAnswers([]);
      }
      return { data: userAnswers, isCorrect: false, points: 0 };
    },
  }));

  useEffect(() => {
    setGridShown(true);
    setFoundWordsArray(words.map(() => false));
    updateGridSize();
  }, [currentQuestionIndex, setGridShown, setFoundWordsArray, words, updateGridSize]);

  return {};
};
